import { Observable } from 'rxjs';
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GatewayOrder } from '../../../models/GatewayOrder';
import { Order } from '../../../models/Order';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { Customer } from '../../../models/Customer';
import { Invoice } from '../../../models/Invoice';

@Component({
  selector: 'app-order-widget',
  templateUrl: './order-widget.component.html',
  styleUrls: ['./order-widget.component.css'],
  imports: [MatIconModule, MatTooltipModule, MatCardModule, CommonModule]
})
export class OrderWidgetComponent {
  @Input() gatewayOrder?: GatewayOrder | null;
  @Input() order?: Order | null;
  @Input() customer?: Customer | null;
  // @Input() invoice?: Invoice | null;
}
